import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import Widget from "./Agency/Widget";

function AgencyDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const agencyId = location?.state?.agencyId;
  const agencyName = location?.state?.agencyName || "Agency";
  return (
       <Box sx={{ p: { xs: 2, sm: 4 }, width: '100%', minWidth: 0, mt: 0 }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <IconButton onClick={() => navigate(-1)} size="small">
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h6" sx={{ fontWeight: 600, ml: 1 }}>
          {agencyName}
        </Typography>
      </Box>

      {/* Clone of Agency/Widget content */}
      <Widget selectedUserId={agencyId} />
    </Box>
  );
}

export default AgencyDetails;


